<template>
  <!-- サービスレベル表の出力内容 -->
  <div
    id="service-level-print-area"
    style="display: none"
  >
    <h2>サービスレベル表</h2>
  </div>
</template>
<script lang="ts">
export default {
  name: 'YhcServiceLevelExportContents',
  data() {
    return {
      // データをここに追加
    }
  },
  methods: {
    // メソッドをここに追加
  },
}
</script>
<style lang="scss" scoped></style>
